import { http } from '@api/client';
import { PaginatedResponse } from '@api/shared';
import { paramterize, pickResponse } from '@api/utils';
import { cachedApi } from '@api/utils';

// export function roleSearch() {
//   return http.get('/person-role').pipe(pickResponse(), pickResponse());
// }

export const roleSearch = cachedApi(() =>
  http.get('/person-role').pipe(pickResponse(), pickResponse())
);
export const subRoleSearch = cachedApi(() =>
  http.get('/person-subrole').pipe(pickResponse(), pickResponse())
);
